import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import {
  qrCornetsInterior,
  qrCornetsOuter,
  qrPattern,
  setIsSingleColorDots,
} from "../../../../../redux/slices/qrSettings";
import { CustomCol, FrameItem } from "../../framesQr/QrFrameItems";
import { Row, Form } from "react-bootstrap";
import QrPatternSingleColor from "./QrPatternSingleColor";
import QrPatternGradientColor from "./QrPatternGradientColor";
import {
  Classy,
  ClassyRounded,
  Dots,
  DotsHorizontal,
  DotsVertical,
  ExtraRounded,
  Random,
  RandomDots,
  Rhombus,
  RhombusVertical,
  Rounded,
  RoundedStripe,
  SmallDots,
  SmallSquare,
  Square,
  SquareStripe,
} from "./svg";
import { designTypes } from "../../../../../constants/common";

const array = [
  { id: 1, pattern: "square", component: <Square /> },
  { id: 2, pattern: "classy", component: <Classy /> },
  { id: 3, pattern: "classy-rounded", component: <ClassyRounded /> },
  { id: 4, pattern: "rounded", component: <Rounded /> },
  { id: 5, pattern: "extra-rounded", component: <ExtraRounded /> },
  { id: 6, pattern: "random", component: <Random /> },
  { id: 7, pattern: "square-stripe", component: <SquareStripe /> },
  { id: 8, pattern: "dots", component: <Dots /> },
  { id: 9, pattern: "dots-horizontal", component: <DotsHorizontal /> },
  { id: 10, pattern: "dots-vertical", component: <DotsVertical /> },
  { id: 11, pattern: "rhombus-vertical", component: <RhombusVertical /> },
  { id: 12, pattern: "rounded-stripe", component: <RoundedStripe /> },
  { id: 13, pattern: "random-dots", component: <RandomDots /> },
  { id: 14, pattern: "rhombus", component: <Rhombus /> },
  { id: 15, pattern: "small-square", component: <SmallSquare /> },
  { id: 16, pattern: "small-dots", component: <SmallDots /> },
];

const artPatterns = [
  { id: 1, pattern: "small-dots", component: <SmallDots /> },
  { id: 5, pattern: "rhombus", component: <Rhombus /> },
  { id: 6, pattern: "small-square", component: <SmallSquare /> },
  { id: 4, pattern: "random-dots", component: <RandomDots /> },
  { id: 3, pattern: "rounded-stripe", component: <RoundedStripe /> },
  { id: 2, pattern: "square-stripe", component: <SquareStripe /> },
];

function QrPattern() {
  const isSingleColorDots = useSelector(
    (state) => state.qrSettings.isSingleColorDots
  );
  const statePattern = useSelector((state) => state.qrSettings.pattern);
  const lang = useSelector((state) => state.changeLang.language.stepThree);
  const cornetsOuter = useSelector((state) => state.qrSettings.cornetsOuter);
  const cornetsInterior = useSelector(
    (state) => state.qrSettings.cornetsInterior
  );
  const designType = useSelector((state) => state.customizeQr.designType);

  const dispatch = useDispatch();
  const [pattern, setPattern] = useState(statePattern);

  useEffect(() => {
    setPattern(statePattern);
  }, [statePattern]);

  useEffect(() => {
    dispatch(qrPattern(pattern));
  }, [pattern]);

  const handleChangePattern = (pattern) => {
    setPattern(pattern);
    if (!cornetsOuter) dispatch(qrCornetsOuter("square"));
    if (!cornetsInterior) dispatch(qrCornetsInterior("square"));
  };

  const patterns = designType === designTypes.art ? artPatterns : array;

  return (
    <>
      <div className="fw-bold fs-4 mb-3 mb-md-4 text-capitalize">
        {lang.pattern[3]}
      </div>
      <Row className="g-2 g-lg-3 mb-4">
        {patterns.map((i) => {
          return (
            <CustomCol xs={3} key={i.id}>
              <FrameItem
                onClick={() => handleChangePattern(i.pattern)}
                className={classNames(
                  "d-flex justify-content-center align-items-center border rounded-1 p-2",
                  {
                    "border-primary": i.pattern === pattern,
                    "border-border-gray": i.pattern !== pattern,
                  }
                )}
              >
                <div className="m-1">{i.component}</div>
              </FrameItem>
            </CustomCol>
          );
        })}
      </Row>
      <div
        key="inline-radio"
        className="mb-3 d-flex justify-content-start gap-4 fs-7"
      >
        <Form.Check
          checked={isSingleColorDots}
          type="radio"
          label={lang.gradient[0]}
          name="qrPatternColor"
          id="inline-radio-single"
          onChange={() => dispatch(setIsSingleColorDots(!isSingleColorDots))}
        />
        <Form.Check
          checked={!isSingleColorDots}
          type="radio"
          label={lang.gradient[1]}
          name="qrPatternColor"
          id="inline-radio-gradient"
          onChange={() => dispatch(setIsSingleColorDots(!isSingleColorDots))}
        />
      </div>
      {isSingleColorDots ? (
        <QrPatternSingleColor />
      ) : (
        <QrPatternGradientColor />
      )}
    </>
  );
}

export default QrPattern;
